import { render, staticRenderFns } from "./WorkBasicDialog.vue?vue&type=template&id=84074308&scoped=true"
import script from "./WorkBasicDialog.vue?vue&type=script&lang=js"
export * from "./WorkBasicDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkBasicDialog.vue?vue&type=style&index=0&id=84074308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84074308",
  null
  
)

export default component.exports